/** @format */
import axios from '../../libs/axios';
import { models } from '@/config/models';
import config from '@/config/config';
const state = {
  version: { actual: 0, build: config.version, evaluted: false },

  data: {},
  phoneBar: false,
  params: null,
  typeClick: null,
  interfaceConfig: {},
  filters: {},
};

const getters = {
  getVersion: (state) => state.version,
  get: (state) => state.data,
  access: (state) => state.data,
  getPhoneBar: (state) => state.phoneBar,
  getLocalParams: (state) => {
    let params = state.params;
    if (!params) {
      try {
        params = JSON.parse(localStorage.getItem('user-params'));
      } catch {}
      if (!params) {
        params = {};
        //localStorage.setItem('user-params', JSON.stringify(params));
      }
      state.params = params;
    }
    return state.params;
  },

  getSessionFilter: (state, name) => {
    let filters = state.filters;
    return filters;
  },
  getInterfaceConfig: (state) => {
    let interfaceConfig = state.interfaceConfig;
    if (!interfaceConfig) {
      try {
        interfaceConfig = state.data.config?.interface || {};
      } catch {}
      if (!interfaceConfig) {
        interfaceConfig = {};
        //localStorage.setItem('user-params', JSON.stringify(params));
      }
      state.interfaceConfig = interfaceConfig;
    }
    return state.interfaceConfig;
  },
  getTypeClick: (state) => {
    let type = state.typeClick;
    const def = 1;
    if (!type) {
      try {
        type = JSON.parse(localStorage.getItem('typeClick'));
        if (!type) type = state.data.config?.interface?.typeClick;
      } catch {}
      if (!type) {
        type = def;
        //localStorage.setItem('user-params', JSON.stringify(params));
      }
      state.typeClick = type;
    }
    return state.typeClick;
  },
};

const actions = {
  fitch: async ({ commit, dispatch }) => {
    let data = {};
    data.model = {};

    let enums = {
      destinations: [
        { value: 0, text: 'Исходящий' },
        { value: 1, text: 'Входящий' },
      ],
      callStatuses: [
        { value: 0, text: 'Не отвечен' },
        { value: 1, text: 'Отвечен' },
      ],
    };

    const resp = await axios.get('/config');
    let d = Object.assign({}, resp.data);
    try {
      const mm = d.config?.mainMenu || [];
      const menuP = Array.isArray(mm) ? mm : Object.values(mm);
      d.config.mainMenu = menuP;
    } catch (error) {}
    const model = d.config.models;
    //console.log('config 2', resp.data);
    const keys = Object.keys(d.config);
    let m = {};

    for (const key in d.config) {
      if (key.includes('models.')) {
        m[key.split('.')[1]] = Object.assign({}, d.config[key]);
      }
      if (key.includes('models__')) {
        const n = key.split('__')[1];
        if (models?.[n]?.useLocal && process.env.NODE_ENV === 'development') {
          console.log('use local ONLY', n);
        } else {
          //m[key.split('__')[1]] = Object.assign({}, d.config[key]);
          m[key.split('__')[1]] = JSON.parse(JSON.stringify(d.config[key]));
        }
      }
      if (key.includes('statuses.') || key.includes('statuses__')) {
        if (!d.config?.statuses) d['statuses'] = {};
        d.config.statuses = Object.assign({}, d.config.statuses, d.config[key]);
      }
      if (key.includes('dictionary__')) {
        if (!d.config?.dictionary) d['dictionary'] = {};
        d.config.dictionary[key.split('__')[1]] = d.config[key];
      }
    }

    //d.models = Object.assign({}, model, m);
    d.models = Object.assign({}, models, model, m);
    //console.log('/config 1', d);

    commit('set', d);

    //commit('set', { models, enums });
  },

  async checkVersion({ state, commit, dispatch }, data) {
    let ver = state.version;
    axios.get('/config/config.version').then((resp) => {
      if (resp.data.status === 'ok') {
        ver.actual = resp.data.data;
        commit('setVersion', ver);
      }
    });
  },
};

const mutations = {
  set: (state, resp) => {
    state.data = resp;
  },

  setVersion: (state, resp) => {
    state.version = resp;
  },
  setPhoneBar: (state, r) => {
    state.phoneBar = !state.phoneBar;
  },
  setLocalParams: (state, { name, value }) => {
    let params = state.params;
    if (!value && value !== 0) {
      delete params[name];
    } else {
      params[name] = value;
    }
    console.log('set ', name, value);
    localStorage.setItem('user-params', JSON.stringify(params));
    state.params = params;
  },
  setSessionFilter: (state, { name, value }) => {
    let filters = state.filters;
    if (!value && value !== 0) {
      delete filters[name];
    } else {
      filters[name] = value;
    }
    state.filters = filters;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
